<template>
<div class="shipped-content-title">
  <div class="shipped-content">
        <div class="shipped-content-title medium">
          <div> Refund under review</div>
        </div>
    </div>
    <m-drawer ref="mDrawer"></m-drawer>
</div>
</template>

<script>
import mDrawer from './m-drawer.vue'
export default {
  name: 'contentTitle',
  components: {mDrawer},
  props: {
    type: {
      default: '',
      type: String
    }
  },
  methods: {
    openDraw() {
      this.$refs.mDrawer.mDrawer = true
    }
  }
}
</script>
<style lang="less" scoped>
@media screen and (max-width: 1024px) {
  .pc-shipped-content-title{
    display: none !important;
  }
  .m-shipped-content-title{
    display: block !important;
    text-decoration: underline;
  }
  .shipped-content{
    width: 100% !important;
  }
  .shipped-content{
    margin-top: 0 !important;
  }
}

.shipped-content{
  width: 100%;
  margin:  0 auto;
  margin-top: 30px;
  box-sizing: border-box;
  border: 1px solid #E1E1E1;
  .shipped-content-title{
    height: 60px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
  }
  .pc-shipped-content-title{
    width: 177px;
    height: 40px;
    background: #262613;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
  }
}

.m-shipped-content-title{
  display: none;
}
.medium{
  font-family: Satoshi-medium;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/content-title.vue